// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"63159ab6583a455f","929":"58160a0aec919bbc"}[chunkId] + ".css";
};